import { MapTool } from '@bs/map';
import { polygon as turfPolygon } from '@turf/turf';
import Feature from 'ol/Feature';
import { GeoJSON } from 'ol/format';
import { Point, Polygon } from 'ol/geom';
import { Circle as CircleStyle, Fill, Icon, Text as OLTEXT, Stroke, Style } from 'ol/style';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import React, { Component } from 'react';
import LoadingPanel from '../LoadingPanel';
import { TreeService } from './TreeService';
// imports (module build)
import * as turf from '@turf/turf';
import otherTool from '../../tools/otherTool';

import Overlay from "ol/Overlay";

import LineString from "ol/geom/LineString";

import { getArea, getLength } from "ol/sphere";
import { Dialog } from 'primereact/dialog';

import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Panel } from 'primereact/panel';


import { HierarchicalQueryDb } from '@bs/bms-hierarchical-query';
import Snap from 'ol/interaction/Snap';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Badge } from 'primereact/badge';

import { DataTable } from 'primereact/datatable';

import { Column } from 'primereact/column';

import {
    createBox
} from 'ol/interaction/Draw.js';

import { toLonLat } from 'ol/proj';

import TileLayer from 'ol/layer/Tile';

import { OSM, TileDebug } from 'ol/source';

import MultiPoint from 'ol/geom/MultiPoint.js';
import { transform } from 'ol/proj';
import { withTranslation } from 'react-i18next';
import { GeometryMenuRequest } from './GeometryMenuRequest';
import requestTool from '../../tools/requestTool';
import { cleanupGeometryOperationArtifacts } from '../../utils/mapGeometryCleanup';

class AddGeometryComponent extends Component {
    toastBC = React.createRef();
    toastInfo = React.createRef();

    mapTool = null;
    heartbeatRef = null;

    constructor(props) {
        super(props);
        this.state = {
            selectedDraw: null,
            isLoading: false,
            visibleDialogCity: false,
            optionsCity: null,
            optionsDistrict: null,
            optionsNeighborhood: null,
            selectedCities: [],
            selectedDistricts: [],
            selectedNeigborhoods: [],
            showIsochroneDrawDialog: false,
            duration: null,
            mode: null,
            seconds: 0,
            isDuration: null,
            isPedestrian: null,
            isochronePointCoordinates: null,
            geomType: null,
            isCutShowDialog: false,
            copyCutFeatureList: [],
        };

    }

    drawModifyInteraction = null;

    graticuleLayer = null;

    grid = null;

    addFeatureHistoryList = []; // Eklenen feature'ların tarihçesi

    currentAddIndex = -1; // Eklenen feature'lar için mevcut index

    //Modify işlemlerinde kesişime uymuyorsa önceki geometriyi tutar
    //Modify işlemlerinde kesişime uymuyorsa önceki geometriyi tutar
    lastGeometry = null;

    isHistoryFeature = (feature) => {
        const geometry = feature?.getGeometry?.();
        return !!geometry
            && !feature.get("is_snap")
            && !feature.get("layer_id")
            && !feature.get("layer_id_poi")
            && !feature.get("isochrone_start_point")
            && !feature.get("add_poi");
    };

    getHistoryGeometry = (features) => {
        if (features.length === 1) {
            return features[0].getGeometry().clone();
        }

        const polygonFeatures = features.filter(feature => {
            const geometryType = feature.getGeometry()?.getType?.();
            return geometryType === "Polygon" || geometryType === "MultiPolygon";
        });

        if (polygonFeatures.length < 2) {
            return features[features.length - 1].getGeometry().clone();
        }

        try {
            return this.mapTool.transformGeometry(
                this.mapTool.unionFeatures(polygonFeatures).getGeometry(),
                "EPSG:4326",
                "EPSG:3857"
            );
        } catch {
            // History should never block the draw operation; keep the latest geometry snapshot.
            return features[features.length - 1].getGeometry().clone();
        }
    };

    addFeatureToHistory = () => {
        const source = this.mapTool.getLayerSource("workspace-layer");
        const features = source.getFeatures().filter(this.isHistoryFeature);

        if (features.length === 0) return;

        features.forEach(_feature => {
            this.setModifyStyle(_feature);
        })

        const geometry = this.getHistoryGeometry(features);

        // Clone as a new feature for history
        const historyFeature = new Feature({ geometry });
        this.setModifyStyle(historyFeature);

        // Trim redo stack if new action is inserted mid-history
        if (this.currentAddIndex < this.addFeatureHistoryList.length - 1) {
            this.addFeatureHistoryList = this.addFeatureHistoryList.slice(0, this.currentAddIndex + 1);
        }

        this.addFeatureHistoryList.push(historyFeature);
        this.currentAddIndex = this.addFeatureHistoryList.length - 1;

        console.log("History updated:", this.currentAddIndex);
    };


    closeAddGeometry = async (e) => {


        e.feature.setId('generated-id-' + Date.now());

        var _featureIntersectResult = await this.checkIntersectRule(e.feature);
        if (!_featureIntersectResult) {
            return;
        }
        e.feature.setGeometry(_featureIntersectResult.getGeometry());


        this.addFeatureToHistory(e.feature);

        this.mapTool.disableInteraction("addGeometry");
    }

    closeAddGeometryPoint = (e) => {
        this.checkIntersectRule(e.feature);

        e.feature.setId('generated-id-' + Date.now());

        this.addFeatureToHistory(e.feature);


        this.mapTool.disableInteraction("addGeometry_point");
    }

    closeAddGeometryLineString = (e) => {
        this.checkIntersectRule(e.feature);

        e.feature.setId('generated-id-' + Date.now());

        this.addFeatureToHistory(e.feature);


        this.mapTool.disableInteraction("addGeometry_line");
    }
    setModifyStyle = (feature) => {
        feature.setStyle([
            new Style({
                stroke: new Stroke({
                    color: 'black',
                    width: 3,
                }),
                fill: new Fill({
                    color: 'rgba(60, 200, 255, 0.45)',
                }),
            }),
            new Style({
                image: new CircleStyle({
                    radius: 5,
                    fill: new Fill({
                        color: 'orange',
                    }),
                }),
                geometry: function (feature) {
                    const geometry = feature.getGeometry();
                    if (geometry.getType() === 'Polygon') {
                        return new MultiPoint(geometry.getCoordinates()[0]);
                    }
                    if (geometry.getType() === 'LineString') {
                        return new MultiPoint(geometry.getCoordinates());
                    }
                    if (geometry.getType() === 'Point') {
                        return geometry;
                    }
                    if (geometry.getType() === 'MultiPolygon') {
                        const coordinates = geometry.getCoordinates();
                        const points = coordinates.flatMap(polygon => polygon[0]);
                        return new MultiPoint(points);
                    }
                    return null;
                },
            }),
        ]);
    };


    closeCutInteraction = async (event) => {

        this.cleanupTemporaryGeometryArtifacts({ disableInteractions: false, clearCutCopyLayer: false });

        const { t } = this.props;

        const source = this.mapTool.getLayerSource('workspace-layer');

        const drawFeature = event.feature.clone();

        const drawGeometry = drawFeature.getGeometry();

        const drawGeoJson = new GeoJSON().writeGeometryObject(drawGeometry);

        setTimeout(function () {

            source.removeFeature(event.feature);
        }, 50);


        source.getFeatures().forEach(async (feature) => {

            if (feature !== drawFeature) {

                const featureGeometry = feature.getGeometry();

                const featureGeoJson = new GeoJSON().writeGeometryObject(featureGeometry);

                const turfDrawPolygon = turfPolygon(drawGeoJson.coordinates);

                //if (featureGeoJson.type != "Polygon") {

                //    return;
                //}

                //let turfFeaturePolygon = turfPolygon(featureGeoJson.coordinates);

                //const isWithin = booleanWithin(turfFeaturePolygon, turfDrawPolygon);

                //if (isWithin) {

                //    source.removeFeature(feature);

                //    return;
                //}

                //const isIntersect = turfIntersect(featureGeoJson, drawGeoJson);

                //if (!isIntersect) {

                //    return;

                //}

                //const cutResult = turfDifference(turfFeaturePolygon, turfDrawPolygon);

                //if (cutResult) {

                //    const cutFeature = new GeoJSON().readFeature(cutResult);

                //    if (cutFeature.getGeometry().getType() == "MultiPolygon") {

                //        const polygons2 = cutFeature.getGeometry().getPolygons();

                //        polygons2.forEach((polygon) => {

                //            source.addFeature(new Feature(polygon));

                //        });


                //    }
                //    else {
                //        source.addFeature(cutFeature);
                //    }
                //    source.removeFeature(feature);

                //    this.checkIntersectRule(cutFeature);

                //    return;

                //}

                try {

                    let requestData = {

                        area1: MapTool.convertToWkt(feature, 'EPSG:4326', 'EPSG:3857'),

                        area2: MapTool.convertToWkt(drawFeature, 'EPSG:4326', 'EPSG:3857')
                    };

                    let response = await TreeService.DifferenceTwoGeometry(requestData);


                    if (response.success) {

                        this.setState({ isCutShowDialog: true });

                        let newFeature = MapTool.convertToFeature(response.data.difference, "EPSG:4326", "EPSG:3857");
                        if (this.props.onCutIntersection) {
                            if (response.data.cutIntersection && response.data.cutIntersection !== "POLYGON EMPTY") {

                                let newFeatureIntersecton = MapTool.convertToFeature(response.data.cutIntersection, "EPSG:4326", "EPSG:3857");
                                let newFeatureIntersecton4326 = MapTool.convertToFeature(response.data.cutIntersection, "EPSG:4326", "EPSG:4326");
                                this.setState({ copyCutFeatureList: [...this.state.copyCutFeatureList, { id: this.state.copyCutFeatureList.length, name: t("addGeometry.cutAreaLabel"), feature: newFeatureIntersecton, feature4326: newFeatureIntersecton4326 }] });

                            }
                        }

                        if (newFeature) {

                            if (newFeature.getGeometry().getType() == "MultiPolygon") {

                                const polygons3 = newFeature.getGeometry().getPolygons();

                                polygons3.forEach((polygon) => {
                                    let f = new Feature(polygon);
                                    this.setModifyStyle(f);
                                    source.addFeature(f);

                                });
                                source.removeFeature(feature);
                                return;
                            }
                            else {
                                this.setModifyStyle(newFeature);

                                source.addFeature(newFeature);

                                source.removeFeature(feature);
                            }
                            // this.checkIntersectRule(newFeature);

                            return;


                        }


                    }


                } catch (e) {

                }


            }

        });

    }

    closeAddGeometryCircle = async (e) => {

        if (e.feature) {

            let polygon = this.circleToPolygon(e.feature.getGeometry());
            var _featureIntersectResult = await this.checkIntersectRule(polygon);
            //İleri ve Geri butonu için history eleman ekleme
            if (_featureIntersectResult) {
                e.feature.setGeometry(_featureIntersectResult.getGeometry());
            }
            const layerSource = this.mapTool.getLayerSource('workspace-layer');

            setTimeout(function () {

                layerSource.removeFeature(e.feature);
            }, 50)

            layerSource.addFeature(polygon);

            this.checkIntersectRule(polygon);

            polygon.setId('generated-id-' + Date.now());

            this.addFeatureToHistory(polygon);


            this.mapTool.disableInteraction("addGeometry_circle");

        }

    }

    circleToPolygon = (circle, sides = 64) => {
        const center = circle.getCenter();
        const radius = circle.getRadius();
        const points = [];
        for (let i = 0; i < sides; i++) {
            const angle = (i * 2 * Math.PI) / sides;
            const dx = radius * Math.cos(angle);
            const dy = radius * Math.sin(angle);
            points.push([center[0] + dx, center[1] + dy]);
        }
        points.push(points[0]); // Close the polygon by adding the first point at the end
        let polygon = new Polygon([points]);

        return new Feature(polygon);
    };

    onModifyStart = (e) => {
        const f = e.features.getArray()[0];
        if (f) this.lastGeometry = f.getGeometry().clone(); // keep in EPSG:3857
    };

    computeModifyDeltaFeatureSafe = (newFeature3857) => {
        if (!this.lastGeometry) return { ok: true, delta: null };

        try {
            const format = new GeoJSON({ featureProjection: 'EPSG:3857' });

            const oldGeom3857 = this.lastGeometry.clone();
            const newGeom3857 = newFeature3857.getGeometry().clone();

            const oldGJ = format.writeGeometryObject(oldGeom3857);
            const newGJ = format.writeGeometryObject(newGeom3857);

            // Turf difference işlemleri
            const added = turf.difference(newGJ, oldGJ);
            const removed = turf.difference(oldGJ, newGJ);

            let xor = null;
            if (added && removed) xor = turf.union(added, removed);
            else xor = added || removed;

            if (!xor) {
                return { ok: true, delta: null };
            }

            const deltaFeature = format.readFeature(xor);
            return { ok: true, delta: deltaFeature };

        } catch (err) {
            console.error('Turf modify delta error:', err);
            return {
                ok: false,
                error: 'TURF_COMPUTE_ERROR'
            };
        }
    };


    modifyEnd = async (e) => {
        const { t } = this.props;
        const feature = e.features.getArray()[0];

        // 🔒 Güvenlik: rollback için referans
        const rollbackGeometry = this.lastGeometry
            ? this.lastGeometry.clone()
            : null;

        // 1️⃣ Turf işlemini SAFE şekilde yap
        const deltaResult = this.computeModifyDeltaFeatureSafe(feature);

        if (!deltaResult.ok) {
            // ❌ Turf hata verdi → geri al
            if (rollbackGeometry) {
                feature.setGeometry(rollbackGeometry);
            }

            this.props.toast.current.show({
                severity: 'error',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_geometry_process_error')
            });

            return;
        }

        const deltaFeature = deltaResult.delta;

        // 2️⃣ Değişiklik yoksa → geçerli
        if (!this.shouldSendDelta(deltaFeature)) {
            this.setModifyStyle(feature);
            this.props.toast.current.show({
                severity: 'success',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_drawing_valid')
            });
            return;
        }

        // 3️⃣ Backend intersect kuralı (delta ile)
        let resp;
        try {
            resp = await this.checkIntersectRuleModifyDelta(deltaFeature, true, true);
        } catch (err) {
            console.error('Intersect API error:', err);

            if (rollbackGeometry) {
                feature.setGeometry(rollbackGeometry);
            }

            this.props.toast.current.show({
                severity: 'error',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_server_error')
            });

            return;
        }

        if (!resp?.success) {
            // ❌ Kural ihlali
            if (!resp?.data) {
                // Backend düzeltme vermedi → komple geri al
                if (rollbackGeometry) {
                    feature.setGeometry(rollbackGeometry);
                }
            } else {
                // Backend düzeltilmiş geometri döndü
                const fixed = MapTool.convertToFeature(
                    resp.data,
                    'EPSG:4326',
                    'EPSG:3857'
                );
                feature.setGeometry(fixed.getGeometry());
            }

            this.props.toast.current.show({
                severity: 'warn',
                summary: t('addGeometry.toast_info'),
                detail: resp?.message ?? t('addGeometry.toast_intersection_rule_applied')
            });

            return;
        }

        // ✅ Her şey OK
        this.setModifyStyle(feature);
        this.props.toast.current.show({
            severity: 'success',
            summary: t('addGeometry.toast_info'),
            detail: t('addGeometry.toast_drawing_valid')
        });
    };




    checkIntersectRuleModifyDelta = async (deltaFeature3857, isReturn, isModify) => {
        const { t } = this.props;
        this.setState({ isLoading: true });

        const node = this.props.selectedNode;

        // Reuse your WKT converter for the delta feature
        const deltaWkt = MapTool.convertToWkt(deltaFeature3857, "EPSG:4326", "EPSG:3857");

        const _requestData = {
            layerId: node.id,
            wkt: deltaWkt,   // ONLY the modified part
            isModify
        };

        if (this.props.isDraftMode) {
            _requestData.tableId = this.props.selectedTable.id;
        }

        try {
            const _response = await TreeService.IntersectCheck(_requestData);
            this.setState({ isLoading: false });
            return _response; // raw response
        } catch (e) {
            this.setState({ isLoading: false });
            this.props.toast.current.show({
                severity: 'warn',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_intersection_check_failed')
            });
            return { success: false, data: null };
        }
    };

    shouldSendDelta = (deltaFeature) => {
        if (!deltaFeature) return false;
        const geom = deltaFeature.getGeometry();         // EPSG:3857
        const area = geom.getArea();                     // m²-ish in WebMercator
        const MIN_AREA = 0.5; // tune this (e.g., 0.5 m²)
        return area >= MIN_AREA;
    };




    checkIntersectRule = async (feature, isReturn, isModify) => {
        const { t } = this.props;

        this.setState({ isLoading: true });

        let node = this.props.selectedNode;

        let _wkt = MapTool.convertToWkt(feature, "EPSG:4326", "EPSG:3857");

        let _requestData = {
            layerId: node.id,
            wkt: _wkt,
            isModify: isModify
        }

        if (this.props.isDraftMode) {

            let tableId = this.props.selectedTable.id;

            _requestData.tableId = tableId;

        }

        try {

            let _response = await TreeService.IntersectCheck(_requestData);


            this.setState({ isLoading: false });

            if (isReturn) {
                return _response;
            }
            if (!_response.success) {

                if (_response.data == null) {

                    this.mapTool.findLayer("workspace-layer").getSource().removeFeature(feature);
                    this.props.toast.current.show({ severity: 'warn', summary: t('addGeometry.toast_info'), detail: _response.message });
                    return
                }
                let _feature = MapTool.convertToFeature(_response.data, "EPSG:4326", "EPSG:3857");

                return _feature;
            }


            this.props.toast.current.show({
                severity: 'success',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_drawing_valid')
            });
            return feature;

        } catch (e) {
            if (this.toastInfo.current) {
                return this.props.toast.current.show({
                    severity: 'warn',
                    summary: t('addGeometry.toast_info'),
                    detail: t('addGeometry.toast_intersection_check_failed')
                });
            }



        }

    }

    removeAllInteractions = () => {

        const drawInteraction = this.mapTool.getInteraction("addGeometry");

        drawInteraction.un("drawend", this.closeAddGeometry);

        const drawPointInteraction = this.mapTool.getInteraction("addGeometry_point");

        drawPointInteraction.un("drawend", this.closeAddGeometryPoint);

        const drawLineInteraction = this.mapTool.getInteraction("addGeometry_line");

        drawLineInteraction.un("drawend", this.closeAddGeometryLineString);

        const drawCircleInteraction = this.mapTool.getInteraction("addGeometry_circle");

        drawCircleInteraction.un("drawend", this.closeAddGeometryCircle)

        const drawCutInteraction = this.mapTool.getInteraction("cutGeometry");

        drawCutInteraction.un("drawend", this.closeCutInteraction);

        this.drawModifyInteraction.un('modifyend', this.modifyEnd);
        this.drawModifyInteraction.un('modifystart', this.onModifyStart);


        const measureGeometryInteraction = this.mapTool.getInteraction("measurumentGeometryIntreaction");

        measureGeometryInteraction.un("drawend", this.openMeasurementGeometryPanel);


        const boxGeometryInteraction = this.mapTool.getInteraction("boxGeometryInteraction");

        boxGeometryInteraction.un("drawend", this.closeBoxGeometryInteraction);

        this.mapTool.getMap().un("click", this.ClickedCell);

        const isochronePointInteraction = this.mapTool.getInteraction("isochronePointInteraction");

        isochronePointInteraction.un("drawend", this.drawendIsochronePointInteraction);

        this.mapTool.getMap().un('click', this.setNeighborhoodClick);

        const addPoiInteraction = this.mapTool.getInteraction("addPoiInteraction");

        this.mapTool.getMap().un('drawend', this.closeAddPoiInteraction);


        this.mapTool.getMap().removeInteraction(drawInteraction);
        this.mapTool.getMap().removeInteraction(drawPointInteraction);
        this.mapTool.getMap().removeInteraction(drawLineInteraction);
        this.mapTool.getMap().removeInteraction(drawCircleInteraction);
        this.mapTool.getMap().removeInteraction(drawCutInteraction);
        this.mapTool.getMap().removeInteraction(this.drawModifyInteraction);
        this.mapTool.getMap().removeInteraction(measureGeometryInteraction);
        this.mapTool.getMap().removeInteraction(boxGeometryInteraction);
        this.mapTool.getMap().removeInteraction(isochronePointInteraction);
        this.mapTool.getMap().removeInteraction(addPoiInteraction);

        this.graticuleLayer.setVisible(false);

        this.mapTool.getMap().removeLayer(this.graticuleLayer);


    }

    componentDidMount() {


        this.mapTool = this.props.mapTool;


        this.mapTool.getMap().un('singleclick', window.mapSingleclick);

        const drawLayer = MapTool.createVectorLayer({
            name: "workspace-layer",
            source: MapTool.createVectorLayerSource({})
        });

        const drawLayerCut = MapTool.createVectorLayer({
            name: "cutcopy-layer",
            source: MapTool.createVectorLayerSource({})
        });
        this.mapTool.addLayer(drawLayerCut);
        drawLayer.setZIndex(10);
        this.mapTool.addLayer(drawLayer);
        const drawInteraction = this.mapTool.createDrawInteraction("addGeometry", "workspace-layer", "Polygon");
        drawInteraction.on("drawend", this.closeAddGeometry)
        this.mapTool.addInteraction(drawInteraction);

        const drawPointInteraction = this.mapTool.createDrawInteraction("addGeometry_point", "workspace-layer", "Point");
        drawPointInteraction.on("drawend", this.closeAddGeometryPoint);
        this.mapTool.addInteraction(drawPointInteraction);

        const drawLineInteraction = this.mapTool.createDrawInteraction("addGeometry_line", "workspace-layer", "LineString");
        drawLineInteraction.on("drawend", this.closeAddGeometryLineString);
        this.mapTool.addInteraction(drawLineInteraction);


        const drawCircleInteraction = this.mapTool.createDrawInteraction("addGeometry_circle", "workspace-layer", "Circle");

        drawCircleInteraction.on("drawend", this.closeAddGeometryCircle)

        this.mapTool.addInteraction(drawCircleInteraction);


        const drawCutInteraction = this.mapTool.createDrawInteraction("cutGeometry", "workspace-layer", "Polygon");

        drawCutInteraction.on("drawend", this.closeCutInteraction);

        this.mapTool.addInteraction(drawCutInteraction);


        this.drawModifyInteraction = this.mapTool.createModifyInteraction(
            "draw_modify_interaction",
            "workspace-layer");

        this.drawModifyInteraction.setActive(false);

        this.drawModifyInteraction.on('modifyend', this.modifyEnd);
        this.drawModifyInteraction.on('modifystart', this.onModifyStart);


        this.drawModifyInteraction.on('modifystart', (e) => {
            const feature = e.features.item(0);
            // Değişiklik öncesi geometriyi yedekle          
            this.lastGeometry = feature.getGeometry().clone();

        });

        this.mapTool.addInteraction(this.drawModifyInteraction);

        const measurumentGeometryIntreaction = this.mapTool.createDrawInteraction("measurumentGeometryIntreaction", "workspace-layer", "Point");

        measurumentGeometryIntreaction.on("drawend", this.openMeasurementGeometryPanel);

        this.mapTool.addInteraction(measurumentGeometryIntreaction);

        let boxGeometryInteraction = this.mapTool.createDrawInteraction("boxGeometryInteraction", "workspace-layer", "Circle");

        boxGeometryInteraction.geometryFunction_ = createBox();

        boxGeometryInteraction.on("drawend", this.closeBoxGeometryInteraction);

        this.mapTool.getMap().addInteraction(boxGeometryInteraction);

        let isochronePointInteraction = this.mapTool.createDrawInteraction("isochronePointInteraction", "workspace-layer", "Point");

        isochronePointInteraction.on("drawend", this.drawendIsochronePointInteraction);

        this.mapTool.getMap().addInteraction(isochronePointInteraction);

        let addPoiInteraction = this.mapTool.createDrawInteraction("addPoiInteraction", "workspace-layer", "Point");

        addPoiInteraction.on("drawend", this.closeAddPoiInteraction);

        this.mapTool.getMap().addInteraction(addPoiInteraction);



        this.createGraticuleLayer();

        this.disableAllDrawInteraction();

        this.setState({
            geomType: this.props.layerGeomType
        })

        this.getItem();

        document.addEventListener('keydown', (event) => this.handleKeyDown(event, drawInteraction));
        document.addEventListener('keydown', (event) => this.handleKeyDown(event, drawLineInteraction));
        document.addEventListener("keydown", this.handleKeyDown, false);
        window.addEventListener("beforeunload", this.unLock);
        this.heartbeatRef = setInterval(this.extendExpireTime, 2 * 60 * 1000);

    }

    extendExpireTime = async () => {

        let _id = this.props.selectedNode.id;

        await GeometryMenuRequest.extendTime(_id);


    }

    handleKeyDown = (event, draw) => {

        if (event.ctrlKey && event.key === 'z') {

            draw.removeLastPoint();
        }

        if (event.key === "Escape") {

            //this.clearLayer();

            //this.clearOverlay();

            //this.getItem();

            if (this.props.onDialog) {
                this.props.onDialog();
            }


        }

    }

    closeAddPoiInteraction = (event) => {

        event.feature.set("add_poi", true);

        this.confirm2(event, event.feature);


    }

    savePoi = (feature) => {

        let coord = feature.getGeometry().getCoordinates();

        var transformedPoint = transform(coord, "EPSG:3857", "EPSG:4326");

        let _id = this.props.selectedNode.id;
        const { t } = this.props;

        try {

            this.setState({
                isLoading: true
            });


            let _requestData = {
                dynamicObjectDtos: [{
                    columnName: "poi",
                    columnType: "Geometry",
                    columnValue: JSON.stringify({ type: "Point", coordinates: transformedPoint })
                }],
                id: _id
            };

            if (this.props.isDraftMode) {

                _requestData.tableId = this.props.selectedTable.id;

            };

            TreeService.addGeometry(_requestData).then(res => {
                this.setState({
                    isLoading: false
                })

                if (res.success) {
                    this.props.toast.current.show({
                        severity: 'success',
                        summary: t('addGeometry.toast_info'),
                        detail: t('addGeometry.toast_poi_added')
                    });

                    this.mapTool.viewLayerExtent("workspace-layer", feature, 10);
                }
                else {
                    return this.props.toast.current.show({
                        severity: 'error',
                        summary: t('addGeometry.toast_info'),
                        detail: t('addGeometry.toast_poi_not_added') + '\n' + res.message
                    });
                }

            })



        } catch (e) {
            this.setState({
                isLoading: false
            })
            this.props.toast.current.show({ severity: 'error', summary: t('addGeometry.toast_info'), detail: e.message });
        }

    }

    createGraticuleLayer = () => {

        this.grid = new OSM().getTileGrid({
            tileSize: [512, 512]
        });

        this.graticuleLayer = new TileLayer({
            source: new TileDebug({
                tileGrid: this.grid,
                projection: 'EPSG:3857'
            })
        });

        this.graticuleLayer.set('name', 'graticule_layer');

        this.graticuleLayer.setVisible(false);

        this.mapTool.addLayer(this.graticuleLayer);



        //this.graticuleLayer = new Graticule({
        //    strokeStyle: new Stroke({
        //        color: 'rgba(255,120,0,0.9)',
        //        width: 2,
        //        lineDash: [0.5, 4],
        //    }),
        //    showLabels: true,
        //    visible: false,
        //    wrapX: false,

        //});

        //this.graticuleLayer.set('name', 'graticule_layer');

        //this.mapTool.addLayer(this.graticuleLayer);


    }

    AddFeatureToGraticuleLayer = () => {

        this.disableAllDrawInteraction();

        this.graticuleLayer.setVisible(true);

        const map = this.mapTool.getMap();

        map.on("click", this.ClickedCell);


    }

    ClickedCell = (evt) => {

        const map = this.mapTool.getMap();

        let z = Math.round(map.getView().getZoom());

        let coord = this.grid.getTileCoordForCoordAndZ(evt.coordinate, z);

        let extent = this.grid.getTileCoordExtent(coord);

        const lineString = new LineString([
            [extent[0], extent[1]],
            [extent[0], extent[3]],
            [extent[2], extent[3]],
            [extent[2], extent[1]],
            [extent[0], extent[1]],
        ]);

        const polygon = new Polygon([lineString.getCoordinates()]);

        const feature = new Feature(polygon);

        const polygonStyle = new Style({
            stroke: new Stroke({
                color: 'blue',  // Border color
                width: 3        // Border width
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.5)'  // Fill color with transparency
            })
        });

        feature.setStyle(polygonStyle);

        const source = this.mapTool.getLayerSource("workspace-layer");

        let featureExists = source.getFeaturesAtCoordinate(evt.coordinate)[0];

        if (featureExists) {

            source.removeFeature(featureExists);

            return;

        }


        this.mapTool.getLayerSource("workspace-layer").addFeature(feature);


    }

    formatArea = (polygonGeometry) => {

        let sphericalArea;

        let sphericalOutput = 0;

        try {

            sphericalArea = getArea(polygonGeometry);

            if (sphericalArea > 1000000) {

                sphericalOutput = (Math.round(sphericalArea / 1000000 * 100) / 100) +

                    ' ' + 'km²';

            } else {

                sphericalOutput = (Math.round(sphericalArea * 100) / 100) +

                    ' ' + 'm²';

            }

        } catch (e) {


        }

        return sphericalOutput;

    };

    formatLength = (lineGeometry) => {

        let sphericalOutput = 0;

        let sphericalLength = 0;

        try {

            sphericalLength = getLength(lineGeometry);

            if (sphericalLength > 1000) {

                sphericalOutput =

                    (Math.round((sphericalLength / 1000) * 100) / 100).toLocaleString('de-DE') + " " + "km";

            } else {

                sphericalOutput = (Math.round(sphericalLength * 100) / 100).toLocaleString('de-DE') + " " + "m";

            }

        } catch (e) {


        }

        return sphericalOutput;

    };



    openMeasurementGeometryPanel = (event) => {


        const mapTool = this.mapTool;

        event.target.setActive(false);


        const coordinate = event.feature.getGeometry().getCoordinates();

        const pixel = mapTool.getMap().getPixelFromCoordinate(coordinate);


        setTimeout(function () {

            mapTool.getLayerSource("workspace-layer").removeFeature(event.feature);

        }, 50);



        let coordinates, areaInfo;


        mapTool.getMap().forEachFeatureAtPixel(pixel, (feature) => {


            if (feature.getGeometry().getType() !== "Point") {


                coordinates = feature.getGeometry().getCoordinates();


                if (feature.getGeometry().getType() === "Polygon") {


                    let measureToolTipElement = document.createElement("div");


                    measureToolTipElement.setAttribute("id", "drawMeasure");


                    measureToolTipElement.className = "ol-tooltip ol-tooltip-static add-geometry-overlay";


                    areaInfo = this.formatArea(feature.getGeometry())


                    measureToolTipElement.innerHTML = areaInfo;


                    let measureToolTip = new Overlay({

                        element: measureToolTipElement,

                        offset: [0, -15],

                        positioning: "bottom-center",

                    });


                    measureToolTip.setPosition(feature.getGeometry().getInteriorPoint().getCoordinates());


                    mapTool.getMap().addOverlay(measureToolTip);

                }




            }

        });


        if (!coordinates || !coordinates[0]) {

            return;

        }


        if (coordinates[0] && coordinates[0].length > 2) {

            coordinates = coordinates[0];

        }


        let lengths = [];


        if (coordinates && !coordinates.length < 1) {


            for (let i = 0; i < coordinates.length - 1; i++) {


                const line = new LineString([coordinates[i], coordinates[i + 1]]);


                let length = this.formatLength(line);


                let measureToolTipElement = document.createElement("div");


                measureToolTipElement.setAttribute("id", "drawMeasure");


                measureToolTipElement.className = "tooltip tooltip-measure add-geometry-overlay";


                measureToolTipElement.innerHTML = length;


                let measureToolTip = new Overlay({

                    element: measureToolTipElement,

                    offset: [0, -15],

                    positioning: "bottom-center",

                });


                let centerPoint = line.getFlatMidpoint();


                measureToolTip.setPosition(centerPoint);


                mapTool.getMap().addOverlay(measureToolTip);


                lengths.push(length);

            }

        }


        let lengthModels = [];


        for (let i = 0; i < lengths.length; i++) {


            let lengthModel = { id: i + 1, distance: lengths[i] }


            lengthModels.push(lengthModel);

        }



    }

    clearOverlay = () => {
        document.querySelectorAll(".add-geometry-overlay").forEach((data) => { data.remove() });

    }

    cleanupTemporaryGeometryArtifacts = (options = {}) => {
        cleanupGeometryOperationArtifacts(this.mapTool, {
            clearAdministrativeDrawFeatures: false,
            clearDrawVectorLayer: false,
            clearCutCopyLayer: false,
            ...options
        });
    }


    rotateArea = () => {

        this.disableAllDrawInteraction();

        this.mapTool.enableInteraction("selectRotate");

        this.mapTool.enableInteraction("transformRotate");

    }

    moveDraw = () => {

        this.disableAllDrawInteraction();

        this.mapTool.enableInteraction("selectTranslate");

        this.mapTool.enableInteraction("transformTranslate");

    }

    openAreaInteraction = (e) => {

        this.disableAllDrawInteraction();

        this.mapTool.enableInteraction("measurumentGeometryIntreaction");

    }

    clearMeasurement = () => {
        this.clearOverlay();
    }

    closeBoxGeometryInteraction = async (event) => {
        var _featureIntersectResult = await this.checkIntersectRule(event.feature);
        if (!_featureIntersectResult) {
            return;
        }
        event.feature.setGeometry(_featureIntersectResult.getGeometry());

        event.target.setActive(false);

        this.checkIntersectRule(event.feature);

        event.feature.setId('generated-id-' + Date.now());

        this.addFeatureToHistory(event.feature);


    }
    setDrawAction = (e) => {
        this.disableAllDrawInteraction();
        this.cleanupTemporaryGeometryArtifacts({
            disableInteractions: false,
            clearCutCopyLayer: false
        });
        if (!e.currentTarget.value) {
            return;
        }
        if (e.currentTarget.value === "Polygon") {
            this.mapTool.enableInteraction("addGeometry");
        }

        if (e.currentTarget.value === "AddPoi") {

            this.mapTool.enableInteraction("addPoiInteraction");

        }

        if (e.currentTarget.value === "Point") {
            this.mapTool.enableInteraction("addGeometry_point");
        }
        if (e.currentTarget.value === "Line") {
            this.mapTool.enableInteraction("addGeometry_line");
        }
        if (e.currentTarget.value === "Circle") {
            this.mapTool.enableInteraction("addGeometry_circle");
        }

        if (e.currentTarget.value === "Clear") {

            this.mapTool.findLayer("workspace-layer").getSource().clear();

            this.clearOverlay();

        }

        if (e.currentTarget.value === "Box") {

            this.mapTool.enableInteraction("boxGeometryInteraction");
        }

        if (e.currentTarget.value === "Cut") {

            this.mapTool.enableInteraction("cutGeometry");

        }

        if (!this.mapTool.getInteraction("edit_interaction")) {

            const snap = new Snap({
                source: this.mapTool.findLayer("workspace-layer").getSource(),
                name: 'edit_interaction'
            });
            snap.on("snap", (event) => {
                this.mapTool.getMap().getTargetElement().style.cursor = 'crosshair';
            });
            this.mapTool.getMap().on('pointermove', (event) => {

                const features = this.mapTool.getMap().getFeaturesAtPixel(event.pixel);

                if (features.length < 1) {
                    this.mapTool.getMap().getTargetElement().style.cursor = '';
                }
            });
            this.mapTool.addInteraction(snap);
        }

        this.setState({ selectedDraw: e.currentTarget.value });
    }

    async componentWillUnmount() {

        if (this.heartbeatRef) {
            clearInterval(this.heartbeatRef);
            this.heartbeatRef = null;
        }
        await this.unLock();
        window.addEventListener("beforeunload", this.unLock);
        document.removeEventListener('keydown', this.handleKeyDown);
        this.clear();
        this.clearMeasurement();
        this.removeAllInteractions();
        this.mapTool.getMap().on('singleclick', window.mapSingleclick);

    }

    unLock = async () => {

        let _id = this.props.selectedNode.id;

        await GeometryMenuRequest.deleteLock(_id);

    }

    activeModifyInteraction = () => {
        this.disableAllDrawInteraction();
        this.drawModifyInteraction.setActive(true);
    }

    deleteGeometry = () => {
        const { t } = this.props;
        let _id = this.props.selectedNode.id;

        let _requestData = {
            dynamicObjectDtos: [{
                columnName: "geoloc",
                columnType: "Null",
                columnValue: "null"
            }],
            id: _id,
        }

        if (this.props.isDraftMode) {

            _requestData.tableId = this.props.selectedTable.id;

        }

        TreeService.addGeometry(_requestData).then(res => {
            if (res.success) {
                this.props.toast.current.show({
                    severity: 'success',
                    summary: t('addGeometry.toast_info'),
                    detail: t('addGeometry.toast_geometry_deleted')
                });
                this.mapTool.findLayer("workspace-layer").getSource().clear();
                this.refreshWmsLayers();
            }
            else {
                this.props.toast.current.show({
                    severity: 'error',
                    summary: t('initialize_error_occurred'),
                    detail: t('addGeometry.toast_area_out_of_authority')
                });
            }
        })
    }

    getNeighborhoodInfo = async (id) => {
        const { t } = this.props;
        this.setState({ isLoading: true });

        let res = await TreeService.GetNeighborhoodInfo(id);

        this.setState({ isLoading: false });

        if (!res.success) {
            this.props.toast.current.show({
                severity: 'error',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_administrative_boundary_not_found')
            });
            return;
        }

        let cityMap = new Map();

        res.data.forEach(item => {
            if (!cityMap.has(item.ilId)) {
                cityMap.set(item.ilId, { id: item.ilId, name: item.ilAdi });
            }
        });

        let cityIds = Array.from(cityMap.values());

        let districtMap = new Map();

        res.data.forEach(item => {
            if (!districtMap.has(item.ilceId)) {
                districtMap.set(item.ilceId, { id: item.ilceId, name: item.ilceAdi });
            }
        });

        let districtIds = Array.from(districtMap.values());

        let neighborHoodMap = new Map();

        res.data.forEach(item => {
            if (!neighborHoodMap.has(item.mahId)) {
                neighborHoodMap.set(item.mahId, { id: item.mahId, name: item.mahalleAdi });
            }


        });

        let neighborhoodIds = Array.from(neighborHoodMap.values());

        this.setState({
            selectedCities: cityIds,
            selectedDistricts: districtIds,
            selectedNeigborhoods: neighborhoodIds
        });


    }


    getItem = async (zoomOut = true) => {
        const { t } = this.props;
        let _id = this.props.selectedNode.id;

        let data = {
            key: "id",
            value: _id.toString()
        };
        this.mapTool.findLayer("workspace-layer").getSource().clear();
        this.mapTool.findLayer("cutcopy-layer").getSource().clear();
        this.mapTool.findLayer("draw-layer").getSource().clear();
        this.setState({ isLoading: true });

        try {

            if (this.props.isDraftMode) {

                const tableId = this.props.selectedTable.id;

                const resDraft = await TreeService.queryTableDraft(data, tableId);

                if (!resDraft) {
                    this.props.toast.current.show({
                        severity: 'error',
                        summary: t('addGeometry.toast_info'),
                        detail: t('addGeometry.toast_layer_info_not_found')
                    });
                    this.setState({ isLoading: false });
                    return;
                }
                if (!resDraft.data[0].geoloc_wkt) {
                    this.props.toast.current.show({
                        severity: 'error',
                        summary: t('addGeometry.toast_info'),
                        detail: t('addGeometry.toast_drawing_not_found')
                    });
                    this.setState({ isLoading: false });
                    return;
                }

                let _wkt = resDraft.data[0].geoloc_wkt;

                let _feature = MapTool.convertToFeature(_wkt, "EPSG:4326", "EPSG:3857");

                let _type = _feature.getGeometry().getType();

                this.clearLayer();

                if (_type === "MultiPolygon") {
                    var cooridinates = _feature.getGeometry().getCoordinates();

                    for (var i = 0; i < cooridinates.length; i++) {
                        var feature = new Feature({
                            type: "Polygon",
                            geometry: new Polygon(cooridinates[i]),
                        });

                        feature.set("draw_type", "move");
                        feature.set("draw_type", "copy");
                        this.mapTool.addFeature("workspace-layer", feature);
                    }

                    this.mapTool.viewLayerExtent("workspace-layer", _feature, 10);
                } else {
                    this.mapTool.addFeature("workspace-layer", _feature);
                    this.mapTool.viewLayerExtent("workspace-layer", _feature, 10);
                }

                this.disableAllDrawInteraction();

                return;
            }


            const res = await TreeService.queryTable(data);

            if (!res.success) {
                this.props.toast.current.show({
                    severity: 'error',
                    summary: t('addGeometry.toast_info'),
                    detail: t('addGeometry.toast_layer_info_not_found')
                });
                this.setState({ isLoading: false });
                return;
            }

            if (!res.data[0].geoloc_wkt) {
                this.props.toast.current.show({
                    severity: 'error',
                    summary: t('addGeometry.toast_info'),
                    detail: t('addGeometry.toast_drawing_not_found')
                });
                this.setState({ isLoading: false });
                return;
            }

            let _wkt = res.data[0].geoloc_wkt;

            let _feature = MapTool.convertToFeature(_wkt, "EPSG:4326", "EPSG:3857");

            let _type = _feature.getGeometry().getType();

            this.clearLayer();

            this.setModifyStyle(_feature);

            if (_type === "MultiPolygon") {
                var cooridinates = _feature.getGeometry().getCoordinates();

                for (var i = 0; i < cooridinates.length; i++) {
                    var feature = new Feature({
                        type: "Polygon",
                        geometry: new Polygon(cooridinates[i]),
                    });

                    this.setModifyStyle(feature);
                    feature.set("draw_type", "move");
                    feature.set("draw_type", "copy");


                    this.mapTool.addFeature("workspace-layer", feature);

                }

            } else {
                this.setModifyStyle(_feature);
                this.mapTool.addFeature("workspace-layer", _feature);

            }
            this.mapTool.viewLayerExtent("workspace-layer", _feature);

            this.disableAllDrawInteraction();
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    refreshWmsLayers = () => {
        const openedVmsLayers = this.mapTool.getMap().getLayers().getArray().filter(x => x.getProperties().name.includes("wms-layer-") && x.getVisible() === true);

        for (let i = 0; i < openedVmsLayers.length; i++) {

            this.mapTool.refreshLayer(openedVmsLayers[i].get("name"));


        }

        const current_zoom = this.mapTool.getMap().getView().getZoom();
        this.mapTool.getMap().getView(current_zoom - 0.001);
    }


    saveDraw = async (isCloseForLayerControl) => {
        const { t } = this.props;
        try {

            this.setState({
                isLoading: true
            })

            let newFeatures = this.mapTool.findLayer('workspace-layer').getSource().getFeatures().filter(x => x.get("draw_type") && !x.get("is_snap"));

            if (this.mapTool.findLayer('workspace-layer').getSource().getFeatures().length > 0) {

                let workspaceFeatures = this.mapTool.findLayer('workspace-layer').getSource().getFeatures().filter(x => !x.get("is_snap") && !x.get("layer_id") && !x.get("layer_id_poi") && !x.get('isochrone_start_point') && !x.get("add_poi"));

                newFeatures = newFeatures.concat(workspaceFeatures)
            }
            let addedLayers = ["bs-hierarchial-layercountry", "bs-hierarchial-layercity", "bs-hierarchial-layerdistrict", "bs-hierarchial-layerneighbourhood", "draw-layer"];

            let hierarchialFeatures = [];
            //if (newFeatures.length == 0) {
            //    for (let value of addedLayers) {
            //        let layerNameHierachicals = `${value}`;
            //        if (this.mapTool.findLayer(layerNameHierachicals) && this.mapTool.findLayer(layerNameHierachicals).getSource().getFeatures().length > 0) {

            //            let findFeatures = this.mapTool.findLayer(layerNameHierachicals).getSource().getFeatures();
            //            hierarchialFeatures = hierarchialFeatures.concat(findFeatures)
            //        }

            //    }
            //}
            //Sağ tıktan alana dahil et dediyse
            if (hierarchialFeatures.filter(x => x.get("is_intersect") != null).length > 0) {
                hierarchialFeatures = hierarchialFeatures.filter(x => x.get("is_intersect"));
            }
            newFeatures = newFeatures.concat(hierarchialFeatures)

            if (newFeatures.length < 1) {

                this.props.toast.current.show({
                    severity: 'error',
                    summary: t('addGeometry.toast_info'),
                    detail: t('addGeometry.toast_drawing_not_found')
                });

                this.setState({
                    isLoading: false
                })

                return;
            }

            let newFeature = null;

            if (newFeatures.length == 1) {


                newFeature = newFeatures[0];

                if (newFeature.getGeometry().getType() == "Polygon" || newFeature.getGeometry().getType() == "MultiPolygon") {


                    const wktList = newFeatures.map(feature => {
                        return MapTool.convertToWkt(feature, "EPSG:4326");
                    });

                    let bufferedWkt = await requestTool.postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/SmartTerritory/UnionComplexGeometry", wktList);


                    newFeature = newFeature = MapTool.convertToFeature(bufferedWkt.data, "EPSG:4326", "EPSG:3857");
                }
                else {
                    var newGeometry = transform(newFeature.getGeometry().getCoordinates(), "EPSG:3857", "EPSG:4326");
                    if (newFeature.getGeometry().getType() === "Point") {

                        newFeature = new Feature({
                            name: "Point",
                            geometry: new Point(newGeometry),
                        });
                    }
                    else {
                        const transformCoordinates = newFeature.getGeometry().getCoordinates().map(coord => transform([coord[0], coord[1]], 'EPSG:3857', 'EPSG:4326'));
                        newFeature = new Feature({
                            name: newFeature.getGeometry().getType(),
                            geometry: new LineString(transformCoordinates)
                        });
                    }
                }
            }
            else {
                try {

                    const pointCount = newFeatures.filter(x => x.getGeometry().getType() === 'Point').length;
                    const lineCount = newFeatures.filter(x => x.getGeometry().getType() === 'LineString').length;
                    let isRequired = true;
                    if (pointCount > 1 && lineCount > 1) {
                        this.props.toast.current.show({
                            severity: 'error',
                            summary: t('addGeometry.toast_info'),
                            detail: t('addGeometry.toast_multiple_point_and_line_not_allowed')
                        });
                        isRequired = false;
                    } else if (pointCount > 1) {
                        this.props.toast.current.show({
                            severity: 'error',
                            summary: t('addGeometry.toast_info'),
                            detail: t('addGeometry.toast_multiple_point_not_allowed')
                        });
                        isRequired = false;
                    } else if (lineCount > 1) {
                        this.props.toast.current.show({
                            severity: 'error',
                            summary: t('addGeometry.toast_info'),
                            detail: t('addGeometry.toast_multiple_line_not_allowed')
                        });
                        isRequired = false;
                    }
                    if (!isRequired) {
                        this.setState({
                            isLoading: false
                        });
                        return;

                    }


                    const wktList = newFeatures.map(feature => {
                        return MapTool.convertToWkt(feature, "EPSG:4326");
                    });

                    let bufferedWkt = await requestTool.postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/SmartTerritory/UnionComplexGeometry", wktList);

                    newFeature = MapTool.convertToFeature(bufferedWkt.data, "EPSG:4326", "EPSG:3857");


                } catch (e) {

                    this.setState({
                        isLoading: false
                    })

                    this.props.toast.current.show({
                        severity: 'error',
                        summary: t('addGeometry.toast_info'),
                        detail: t('addGeometry.toast_different_geometry_types_not_allowed')
                    });
                }

            }
            if (!newFeature) {

                this.props.toast.current.show({
                    severity: 'error',
                    summary: t('addGeometry.toast_info'),
                    detail: t('addGeometry.toast_invalid_drawing_found')
                });

                this.setState({
                    isLoading: false
                })

                return;

            }


            let wkt = MapTool.convertToWkt(newFeature, "EPSG:4326", "EPSG:4326");

            //let newFeatureIntersectRule = MapTool.convertToFeature(wkt, "EPSG:4326", "EPSG:3857");

            //let isIntersect = await this.checkIntersectRule(newFeatureIntersectRule, true);

            //if (isIntersect && !isIntersect.success) {

            //    this.props.toast.current.show({ severity: 'error', summary: 'Bilgi', detail: isIntersect.message });

            //    this.setState({
            //        isLoading: false
            //    })

            //    return;
            //}

            let features = [newFeature];

            if (features.length > 0) {

                let feature = features[0];


                if (feature.get("wrongFeature")) {

                    this.props.toast.current.show({
                        severity: 'error',
                        summary: t('addGeometry.toast_info'),
                        detail: t('addGeometry.toast_invalid_drawing_found')
                    });

                    this.setState({
                        isLoading: false
                    })


                    return;
                }

                const _convertedGeometry = feature
                    .getGeometry()
                    .clone()
                    .transform('EPSG:3857', 'EPSG:4326');

                let _convertedFeature = new Feature({
                    geometry: _convertedGeometry
                });

                if (!this.props.selectedNode) {
                    this.props.toast.current.show({
                        severity: 'error',
                        summary: t('addGeometry.toast_info'),
                        detail: t('addGeometry.toast_layer_info_not_found')
                    });

                    this.setState({
                        isLoading: false
                    })


                    return;
                }

                let _id = this.props.selectedNode.id;

                let _geometry = _convertedFeature.getGeometry();

                let _geometryType = _geometry.getType();

                let _coordinates = _geometry.getCoordinates();

                let _requestData = {
                    dynamicObjectDtos: [{
                        columnName: "geoloc",
                        columnType: "Geometry",
                        columnValue: JSON.stringify({ type: _geometryType, coordinates: _coordinates })
                    }],
                    id: _id
                }
                this.setState({
                    isLoading: true
                })

                if (this.props.isDraftMode) {

                    _requestData.tableId = this.props.selectedTable.id;

                }

                TreeService.addGeometry(_requestData).then(res => {
                    this.setState({
                        isLoading: false
                    })


                    if (res.success) {
                        this.props.toast.current.show({
                            severity: 'success',
                            summary: t('addGeometry.toast_info'),
                            detail: t('addGeometry.toast_geometry_added')
                        });
                        if (this.mapTool.findLayer("bs-hierarchial-layer") && this.mapTool.findLayer("bs-hierarchial-layer").getSource().getFeatures().length > 0) {

                            this.mapTool.getLayerSource("bs-hierarchial-layer").clear();

                        }

                        this.clearLayer();
                        this.refreshWmsLayers();
                        if (!isCloseForLayerControl || isCloseForLayerControl.target) {
                            this.getItem(false);
                        }
                        else {
                            if (this.props.onClose) {
                                this.props.onClose(true);
                            }
                        }

                    }
                    else {
                        this.props.toast.current.show({
                            severity: 'error',
                            summary: t('addGeometry.toast_info'),
                            detail: t('addGeometry.toast_geometry_not_updated') + '\n' + res.message
                        });
                    }

                })

            }

        } catch (e) {
            this.props.toast.current.show({ severity: 'error', summary: 'Bilgi', detail: e.message });
            this.setState({
                isLoading: false
            })
        }


    }

    disableAllDrawInteraction = () => {

        this.mapTool.disableInteraction("addGeometry");
        this.mapTool.disableInteraction("addGeometry_point");
        this.mapTool.disableInteraction("addGeometry_line");
        this.mapTool.disableInteraction("addGeometry_circle");
        this.mapTool.disableInteraction("measurumentGeometryIntreaction");
        this.mapTool.disableInteraction("boxGeometryInteraction");
        this.mapTool.disableInteraction("cutGeometry");

        this.mapTool.disableInteraction("selectTranslate");
        this.mapTool.disableInteraction("transformTranslate");

        this.mapTool.disableInteraction("selectRotate");
        this.mapTool.disableInteraction("transformRotate");
        this.mapTool.disableInteraction("isochronePointInteraction");
        this.mapTool.disableInteraction("addPoiInteraction");

        this.mapTool.getMap().un("click", this.ClickedCell);

        this.graticuleLayer.setVisible(false);

        if (this.drawModifyInteraction) {

            this.drawModifyInteraction.setActive(false);
        }
        this.mapTool.getMap().getTargetElement().style.cursor = '';
        this.mapTool.getMap().un('singleclick', window.mapSingleclick);
    }

    clear = () => {
        const { t } = this.props;
        this.disableAllDrawInteraction();

        this.mapTool.findLayer("workspace-layer").getSource().clear();
        this.mapTool.findLayer("cutcopy-layer").getSource().clear();
        //this.clearOverlay();
        this.props.updateParentState(false);
        this.findRemoveMoveFeature(true);
        let contextMenu = this.mapTool.getMap().getControls().getArray().find(x => x.options && x.options.eventType && x.options.eventType === "contextmenu");

        //Harita araçlarından context menuyu bul ve aşağıdaki menu elemanlarını ekle ekle
        if (contextMenu) {
            otherTool.removeContextMenuItem(contextMenu, t('addGeometry.copy'));
            otherTool.removeContextMenuItem(contextMenu, t('addGeometry.move_or_cancel'));


        }

        if (this.props.onClose) {
            this.props.onClose(false);
        }
    }

    copy = () => {

        this.disableAllDrawInteraction();

        otherTool.copyGeometry(this.mapTool, this.toastInfo);

    }

    addFromFile = () => {

        let button = document.getElementById('bs-import-export-tool_2').querySelector("a");

        button.click();
    }

    addHiyerarchicalArea = async () => {

        let _id = this.props.selectedNode.id;

        await this.getNeighborhoodInfo(_id);

        this.setState({ visibleDialogCity: true });

    }

    setNeighborhoodClick = (event) => {

        let featureExists = this.mapTool.getLayerSource('workspace-layer').getFeaturesAtCoordinate(event.coordinate);

        if (featureExists.length > 0) {

            featureExists.forEach(feature => {

                if (!feature.get("neighborhood")) {

                    return;

                }

                if (feature.get('drawNeighborhood')) {

                    feature.set('drawNeighborhood', false);

                    const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;


                    let _text = new OLTEXT({
                        text: feature.get('name'),
                        font: '12px Arial',
                        fill: new Fill({ color: '#000' })

                    });

                    let _style = new Style({

                        stroke: new Stroke({
                            color: color,
                            width: 2
                        }),
                        fill: new Fill({
                            color: `${color}33` // Adding some transparency
                        }),
                        text: _text // Add the text style to the feature
                    });

                    feature.setStyle(_style);

                    return;
                }

                const greenStyle = new Style({
                    fill: new Fill({
                        color: 'rgba(0, 128, 0, 0.5)' // Yarı saydam yeşil renk
                    }),
                    stroke: new Stroke({
                        color: '#008000', // Yeşil renk
                        width: 2
                    })
                });

                // Özelliğin stilini ayarlıyoruz
                feature.setStyle(greenStyle);

                feature.set('drawNeighborhood', true);


                return;
            });


        }

    }

    divedeNeighborhoodsGeoloc = async () => {
        const { t } = this.props;
        this.disableAllDrawInteraction();

        let _id = this.props.selectedNode.id;

        const existFeatures = this.mapTool.getLayerSource('workspace-layer').getFeatures().filter(i => i.get('neighborhood'));

        if (existFeatures.length > 0) {

            existFeatures.forEach(feature => {

                this.mapTool.removeFeature('workspace-layer', feature);

            });

            return;
        }


        this.setState({
            isLoading: true
        })

        const map = this.mapTool.getMap();

        if (map) {

            map.on('click', this.setNeighborhoodClick)

        }

        try {

            if (this.props.isDraftMode) {

                const tableId = this.props.selectedTable.id;

                let resForDraft = await TreeService.DivideAreaForNeighborhoodsByTable(_id, tableId);

                if (!resForDraft.success) {
                    this.props.toast.current.show({
                        severity: 'error',
                        summary: t('addGeometry.toast_info'),
                        detail: resForDraft.message
                    });
                    this.setState({ isLoading: false });
                    return;
                }

                const dataDraftArea = resForDraft.data;

                dataDraftArea.forEach((element, index) => {

                    let newFeature = MapTool.convertToFeature(element.wkt, "EPSG:4326", "EPSG:3857");

                    const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;

                    let _text = new OLTEXT({
                        text: element.name,
                        font: '12px Arial',
                        fill: new Fill({ color: '#000' })

                    });

                    let _style = new Style({

                        stroke: new Stroke({
                            color: color,
                            width: 2
                        }),
                        fill: new Fill({
                            color: `${color}33` // Adding some transparency
                        }),
                        text: _text // Add the text style to the feature
                    });

                    newFeature.setStyle(_style);

                    newFeature.set('neighborhood', true);

                    newFeature.set('name', element.name);

                    this.mapTool.addFeature("workspace-layer", newFeature);
                });

                return;
            }

            let response = await TreeService.DivideAreaForNeighborhoods(_id);

            if (!response.success) {
                this.props.toast.current.show({
                    severity: 'error',
                    summary: t('addGeometry.toast_info'),
                    detail: response.message
                });
                this.setState({ isLoading: false });
                return;
            }

            const data = response.data;

            data.forEach((element, index) => {

                let newFeature = MapTool.convertToFeature(element.wkt, "EPSG:4326", "EPSG:3857");

                const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;

                let _text = new OLTEXT({
                    text: element.name,
                    font: '12px Arial',
                    fill: new Fill({ color: '#000' })

                });

                let _style = new Style({

                    stroke: new Stroke({
                        color: color,
                        width: 2
                    }),
                    fill: new Fill({
                        color: `${color}33` // Adding some transparency
                    }),
                    text: _text // Add the text style to the feature
                });

                newFeature.setStyle(_style);

                newFeature.set('neighborhood', true);

                newFeature.set('name', element.name);

                this.mapTool.addFeature("workspace-layer", newFeature);
            });

        } catch (e) {

        }
        finally {
            this.setState({
                isLoading: false
            })
        }

    }

    getBorders = async () => {
        const { t } = this.props;
        try {



            this.setState({
                isLoading: true
            });

            let _citiesRes = await TreeService.GetCities();

            this.setState({
                isLoading: false
            })

            if (!_citiesRes.success) {

                return;

            }
            let _cities = _citiesRes.data.map(i => ({ id: i.id, name: i.name }));

            this.setState({
                isLoading: true
            });

            let _districtsRes = await TreeService.GetDistricts();


            this.setState({
                isLoading: false
            })

            if (!_districtsRes.success) {

                return;

            }

            let districts = _districtsRes.data.map(i => ({ id: i.id, name: i.name }));

            this.setState({
                optionsCity: _cities,
                optionsDistrict: districts
            });
        } catch (e) {

        }
    }

    findRemoveMoveFeature = (isClear) => {

        let findFeature = null;

        this.mapTool.findLayer('workspace-layer').getSource().getFeatures().forEach(x => {

            if (x.get("draw_type") === "move") {

                if (isClear)
                    this.mapTool.findLayer('workspace-layer').getSource().removeFeature(x);
                else
                    findFeature = x;
            }
        });

        return findFeature;
    }
    clearLayer = () => {
        this.mapTool.findLayer("workspace-layer").getSource().clear();
    }

    contextMenuAddRemoveItemRefresh = () => {
        //this.mapTool.enableInteraction("selectTranslate");
        //this.mapTool.enableInteraction("transformTranslate");
        const { t } = this.props;
        let contextMenu = this.mapTool.getMap().getControls().getArray().find(x => x.options && x.options.eventType && x.options.eventType === "contextmenu");
        //Harita araçlarından context menuyu bul ve aşağıdaki menu elemanlarını ekle ekle
        if (contextMenu) {

            otherTool.removeContextMenuItem(contextMenu, t('addGeometry.context_copy'));

            otherTool.addContextMenu(contextMenu, [{
                text: t('addGeometry.context_copy'),
                callback: (data) => {
                    otherTool.copyGeometry(this.mapTool, this.toastInfo);
                },
                icon: 'pi plus'
            },
            {
                text: t('addGeometry.context_move_or_cancel'),
                callback: (data) => {
                    let interaction = this.mapTool.getInteraction("selectTranslate");
                    if (interaction && interaction.getActive()) {
                        this.mapTool.disableInteraction("selectTranslate");
                        this.mapTool.disableInteraction("transformTranslate");
                        this.props.toast.current.show({
                            severity: 'info',
                            summary: t('addGeometry.toast_info'),
                            detail: t('addGeometry.toast_move_disabled'),
                            sticky: true
                        });
                    }
                    else {
                        this.props.toast.current.show({
                            severity: 'success',
                            summary: t('addGeometry.toast_info'),
                            detail: t('addGeometry.toast_move_enabled'),
                            sticky: true
                        });
                        this.mapTool.enableInteraction("selectTranslate");
                        this.mapTool.enableInteraction("transformTranslate");
                    }


                },
                icon: 'pi plus'
            }

            ], this.mapTool.getMap())
        }
    }

    confirm1 = (event) => {
        const { t } = this.props;
        confirmDialog({
            target: event.currentTarget,
            message: t('addGeometry.confirm_delete_geometry_message'),
            header: t('addGeometry.confirm_delete_geometry_header'),
            icon: 'pi pi-exclamation-triangle',
            accept: this.deleteGeometry,
            reject: this.reject,
            acceptLabel: t('addGeometry.confirm_yes'),
            rejectLabel: t('addGeometry.confirm_no')
        });
    }

    confirm2 = (event, feature) => {
        const { t } = this.props;
        confirmDialog({
            target: event.currentTarget,
            message: t('addGeometry.confirm_add_poi_message'),
            header: t('addGeometry.confirm_add_poi_header'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => this.savePoi(feature),
            reject: this.reject,
            acceptLabel: t('addGeometry.confirm_yes'),
            rejectLabel: t('addGeometry.confirm_no')
        });
    }

    reject = () => {
        return;
    }

    mapBack = () => {
        const source = this.mapTool.getLayerSource("workspace-layer");

        if (this.currentAddIndex <= 0) return;

        this.currentAddIndex--;

        source.clear();

        const feature = this.addFeatureHistoryList[this.currentAddIndex];
        const restored = feature.clone();
        this.setModifyStyle(restored);
        source.addFeature(restored);


        console.log("Geri alındı:", this.currentAddIndex);
    };




    mapForward = () => {
        const source = this.mapTool.getLayerSource("workspace-layer");

        if (this.currentAddIndex >= this.addFeatureHistoryList.length - 1) return;

        this.currentAddIndex++;

        source.clear();

        const feature = this.addFeatureHistoryList[this.currentAddIndex];
        const restored = feature.clone();
        this.setModifyStyle(restored);
        source.addFeature(restored);


        console.log("İleri alındı:", this.currentAddIndex);
    };







    handleCalculate = async () => {
        const { t } = this.props;
        const { isochronePointCoordinates, seconds, isDuration, isPedestrian } = this.state;

        if (!isDuration && seconds < 200) {
            return this.props.toast.current.show({
                severity: 'warning',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_distance_too_small')
            });
        }
        if (!isochronePointCoordinates) {
            this.props.toast.current.show({
                severity: 'error',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_coordinate_not_found')
            });
            return;
        }
        if (isDuration == null) {
            this.props.toast.current.show({
                severity: 'error',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_duration_not_found')
            });
            return;
        }
        if (isPedestrian == null) {
            this.props.toast.current.show({
                severity: 'error',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_vehicle_pedestrian_not_found')
            });
            return;
        }
        if (!seconds) {
            this.props.toast.current.show({
                severity: 'error',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_calculation_not_found')
            });
            return;
        }


        let requestData = {
            latitude: isochronePointCoordinates[1],
            longitude: isochronePointCoordinates[0],
            distance: seconds,
            isDuration: isDuration,
            isPedestrian: isPedestrian,
            fc: 6
        };



        try {
            this.setState({
                isLoading: true
            })
            let responseIsochrone = await TreeService.GetIsochroneDraw(requestData);

            this.setState({
                isLoading: false
            })

            if (!responseIsochrone) {
                this.props.toast.current.show({
                    severity: 'error',
                    summary: t('addGeometry.toast_info'),
                    detail: t('addGeometry.toast_segment_not_found')
                });
                return;
            }
            if (!responseIsochrone.success) {
                this.props.toast.current.show({
                    severity: 'error',
                    summary: t('addGeometry.toast_info'),
                    detail: t('addGeometry.toast_segment_not_found')
                });
                return;
            }

            let coordinates = responseIsochrone.data.coordinates[0];

            if (coordinates.length < 1) {
                this.props.toast.current.show({
                    severity: 'error',
                    summary: t('addGeometry.toast_info'),
                    detail: t('addGeometry.toast_segment_not_found')
                });
                return;
            }

            const transformCoordinates = coordinates.map(coord => transform([coord[0], coord[1]], 'EPSG:4326', 'EPSG:3857'));

            const formattedCoordinates = [transformCoordinates];

            const polygon = new Polygon(formattedCoordinates);

            const feature = new Feature(polygon);

            const polygonStyle = new Style({
                stroke: new Stroke({
                    color: 'blue',  // Border color
                    width: 3        // Border width
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.5)'  // Fill color with transparency
                })
            });

            feature.setStyle(polygonStyle);

            this.mapTool.addFeature("workspace-layer", feature);

            const _extent = this.mapTool.findLayer("workspace-layer").getSource().getExtent();

            this.mapTool.getMap().getView().fit(_extent, {
                padding: [50, 50, 50, 50],
                duration: 1000,
            });

            this.setState({ showIsochroneDrawDialog: false });


        } catch (e) {
            this.props.toast.current.show({
                severity: 'error',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_segment_not_found')
            });
        }


    }

    clearIsochroneInputs = () => {

        this.setState({
            duration: null,
            mode: null,
            seconds: 0,
            isDuration: null,
            isPedestrian: null,
            isochronePointCoordinates: null
        });

    }

    openIsochroneDraw = () => {

        this.disableAllDrawInteraction();

        this.mapTool.enableInteraction("isochronePointInteraction");


    }

    drawendIsochronePointInteraction = (event) => {

        const source = this.mapTool.getLayerSource('workspace-layer');
        if (!event.feature) {

            return;

        }

        const geomCoordinate = toLonLat(event.feature.getGeometry().getCoordinates());


        this.mapTool.disableInteraction("isochronePointInteraction");

        const pointStyle = new Style({
            image: new Icon({
                src: `${process.env.PUBLIC_URL}/marker.png`,
            }),
            text: new OLTEXT({
                text: 'Catchment Başlama Noktası',
                font: 'bold 14px Arial',
                fill: new Fill({
                    color: '#000',
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 2,
                }),
                offsetY: -25,
            }),
        });

        event.feature.setStyle(pointStyle);

        event.feature.set('isochrone_start_point', true);

        this.setState({ showIsochroneDrawDialog: true, isochronePointCoordinates: geomCoordinate });

    }

    handleModeChange = (e) => {

        this.setState({ mode: e.value, isPedestrian: e.target.value.code });
    };

    handleDurationChange = (e) => {
        this.setState({
            duration: e.value, isDuration: e.target.value.code, distance: 0
        });
    }
    removeLayerPoi = () => {
        const { t } = this.props;
        confirmDialog({
            target: null,
            message: t('addGeometry.confirm_remove_poi_message'),
            header: t('addGeometry.confirm_remove_poi_header'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {

                const list = [{
                    columnName: "poi",
                    columnValue: "",
                    columnType: "Geometry"
                }];

                const requestData = {
                    id: this.props.selectedNode.id,
                    dynamicObjectDtos: list

                }
                TreeService.updateLayer(requestData).then(res => {
                    if (res.success) {
                        this.props.toast.current.show({
                            severity: 'success',
                            summary: t('addGeometry.toast_info'),
                            detail: t('addGeometry.toast_poi_removed')
                        });
                        const poi = this.mapTool.findLayer("workspace-layer").getSource().getFeatures().find(x => x.getGeometry().getType() === 'Point');
                        if (poi != null) {
                            this.mapTool.findLayer("workspace-layer").getSource().removeFeature(poi);
                        }

                    } else {
                        this.props.toast.current.show({
                            severity: 'error',
                            summary: t('addGeometry.toast_info'),
                            detail: t('addGeometry.toast_poi_remove_error') + '\n' + res.message
                        });
                    }
                });

            },
            reject: () => { return },
            acceptLabel: t('addGeometry.confirm_yes'),
            rejectLabel: t('addGeometry.confirm_no')
        });


    }
    geometryFixed = async () => {
        const { t } = this.props;
        let node = this.props.selectedNode;

        this.mapTool.findLayer("workspace-layer").getSource().clear();

        let _requestData = {
            layerId: node.id,

        }


        let response = await TreeService.GeometryAutoFixed(_requestData);

        if (response.success) {

            let newFeatureTransorm = MapTool.convertToFeature(response.data, "EPSG:4326", "EPSG:3857").getGeometry();
            let sourceWorkSpaceLayer = this.mapTool.findLayer("workspace-layer").getSource();
            if (newFeatureTransorm.getType() === "MultiPolygon") {


                const polygons = newFeatureTransorm.getPolygons();

                polygons.forEach(polygon => {

                    let f = new Feature(polygon);
                    this.setModifyStyle(f);
                    sourceWorkSpaceLayer.addFeature(f);


                });

            }
            else if (newFeatureTransorm.getType() === "Polygon") {
                let f = new Feature(newFeatureTransorm);
                this.setModifyStyle(f);
                sourceWorkSpaceLayer.addFeature(f);

            }


            this.props.toast.current.show({
                severity: 'success',
                summary: t('addGeometry.toast_info'),
                detail: t('addGeometry.toast_geometry_fixed')
            });
        }

    }
    render() {

        const { t } = this.props;

        if (this.state.isLoading) {


            return (
                <>

                    <Toast ref={this.toastInfo} />
                    <div id="blur">
                        <LoadingPanel />
                    </div>
                </>
            )
        }

        const { selectedCities, selectedDistricts, selectedNeigborhoods, showIsochroneDrawDialog, duration, mode, seconds, geomType } = this.state;

        const durationOptions = [
            { label: t('addGeometry.duration'), code: true },
            { label: t('addGeometry.distance'), code: false }
        ];

        const modeOptions = [
            { label: t('addGeometry.vehicle'), code: false },
            { label: t('addGeometry.pedestrian'), code: true },
        ];

        return (
            <>
                <Toast ref={this.toastInfo} />
                <Toast ref={this.toastInfo} />on
                <div className="flex">

                    <Dialog position={"right"} header={t('addGeometry.additionalOperations')} modal={false} visible={this.state.isCutShowDialog} style={{ width: '20vw' }} onHide={() => {
                        if (!this.state.isCutShowDialog) return;

                        this.setState({ isCutShowDialog: false });
                    }} >
                        <div className="card">
                            <DataTable size="small" value={this.state.copyCutFeatureList} >
                                <Column header={t('addGeometry.operation')} body={(rowData) => {
                                    return (
                                        <div className="card flex">
                                            <Button
                                                icon="pi pi-plus"
                                                tooltip={t('addGeometry.addToTree')}
                                                rounded
                                                text
                                                disabled={this.state.isLoading}
                                                onClick={() => {
                                                    confirmDialog({
                                                        header: t('addGeometry.confirmSaveHeader'),
                                                        message: t('addGeometry.confirmSaveMessage'),
                                                        icon: 'pi pi-exclamation-triangle',

                                                        acceptLabel: t('common.yes'),
                                                        rejectLabel: t('common.no'),

                                                        acceptClassName: 'p-button-success',
                                                        rejectClassName: 'p-button-secondary',

                                                        accept: async () => {
                                                            try {
                                                                // 1) önce kesin kaydet (kapatmadan)
                                                                await this.saveDraw();

                                                                // 2) sonra add to tree
                                                                this.props.onCutIntersection(rowData.feature4326);
                                                            } catch (e) {
                                                                // saveDraw içinde zaten toast varsa burada ekstra bir şey yapmana gerek yok
                                                            }
                                                        },

                                                        reject: () => {
                                                            // hiçbir şey yapma
                                                        }
                                                    });
                                                }}
                                            />
                                            <Button icon="pi pi-eye" tooltip={t('addGeometry.view')} onClick={() => {
                                                let layerName = "cutcopy-layer";
                                                let f = this.mapTool.findLayer(layerName).getSource().getFeatures(x => x.get("featureId") === rowData.id);
                                                rowData.feature.setStyle(this.mapTool.getBackgroundStyle({
                                                    strokeWidth: 1,
                                                    strokeColor: 'maroon',
                                                    fillColor: 'rgba(255, 236, 161, 0.5)',
                                                    label: "name",
                                                    font: '10pt tahoma',
                                                    isExtend: true,
                                                    isOnlyExtend: false,

                                                }, { name: rowData.name }));
                                                if (f.length > 0) {
                                                    this.mapTool.findLayer(layerName).getSource().removeFeature(f[0]);
                                                    if (f[0] != rowData.feature) {
                                                        this.mapTool.findLayer(layerName).getSource().addFeature(rowData.feature);
                                                    }
                                                    return;
                                                }

                                                rowData.feature.set("featureId", rowData.id);
                                                this.mapTool.findLayer(layerName).getSource().addFeature(rowData.feature);

                                            }} rounded text severity="secondary" aria-label="Bookmark" />


                                        </div>
                                    );
                                }}></Column>

                                <Column key={"alan"} field={"name"} header={t('addGeometry.type')} />

                            </DataTable>
                        </div>
                    </Dialog>


                    <Dialog className="dialog-city w-23rem" draggable={true} resizable={false} modal={false} header={t('addGeometry.administrativeBoundaries')} visible={this.state.visibleDialogCity} onHide={() => { this.setState({ visibleDialogCity: false }) }} >
                        <Accordion multiple activeIndex={[0]}>
                            <AccordionTab header={t('addGeometry.intersectingProvinces')}>
                                {selectedCities.map(i => <Badge value={i.name} severity="secondary"></Badge>)}
                            </AccordionTab>
                            <AccordionTab header={t('addGeometry.intersectingDistricts')}>
                                <p className="m-0">
                                    {selectedDistricts.map(i => <Badge value={i.name} severity="secondary"></Badge>)}
                                </p>
                            </AccordionTab>
                            <AccordionTab header={t('addGeometry.intersectingNeighborhoods')}>
                                <p className="m-0">
                                    {selectedNeigborhoods.map(i => <Badge value={i.name} severity="secondary"></Badge>)}
                                </p>
                            </AccordionTab>
                        </Accordion>
                        <HierarchicalQueryDb

                            items={["city", "district", "neighbourhood"]}
                            emptyMessage={t('addGeometry.noRecords')}
                            defaultParameters={
                                {
                                    city: {
                                        firstIds: [],
                                        parentIds: [],
                                        Ids: [],
                                        Id: 0,
                                        selectedId: 0
                                    },
                                    district: {
                                        firstIds: [],
                                        parentIds: [],
                                        Ids: [],
                                        Id: 0,
                                        selectedId: 0
                                    },
                                    neighbourhood: {
                                        firstIds: [],
                                        parentIds: [],
                                        Ids: [],
                                        Id: 0,
                                        selectedId: 0
                                    },
                                    roadLine: {
                                        firstIds: [],
                                        parentIds: [],
                                        Ids: [],
                                        Id: 0,
                                        selectedId: 0
                                    },
                                    doorNumber: {
                                        firstIds: [],
                                        parentIds: [],
                                        Ids: [],
                                        Id: 0,
                                        selectedId: 0,

                                    },
                                }
                            }
                            showDefault={
                                {
                                    country: false,
                                    city: true,
                                    district: true,
                                    neighbourhood: true,
                                    roadLine: false,
                                    doorNumber: false
                                }
                            }
                            IsCenterDistrictAbove={true}
                            IsCenterDistrictKey={t('addGeometry.metropolitanDistrict')}
                            countryIsMultiple={false}
                            cityIsMultiple={true}
                            districtIsMultiple={true}
                            neighbourhoodIsMultiple={true}
                            roadLineIsMultiple={true}
                            doorNumberIsMultiple={true}
                            showLabel={true}
                            defaultStyle={false}
                            countryStyle={{
                                strokeWidth: 1,
                                strokeColor: '#f00',
                                fillColor: 'rgba(185, 150, 255, 0.5)',
                                label: "name",
                                font: '12pt sans-serif',
                                isExtend: true,
                                isOnlyExtend: true,

                            }}
                            cityStyle={{
                                strokeWidth: 1,
                                strokeColor: '#f00',
                                fillColor: 'rgba(185, 251, 255, 0.5)',
                                label: "name",
                                font: '12pt sans-serif',
                                isExtend: true,
                                isOnlyExtend: true,

                            }}
                            districtStyle={{
                                strokeWidth: 1,
                                strokeColor: '#f00',
                                fillColor: 'rgba(175, 255, 161, 0.5)',
                                label: "name",
                                font: '12pt sans-serif',
                                isExtend: true,
                                isOnlyExtend: false,
                            }}
                            neighbourhoodStyle={{
                                strokeWidth: 1,
                                strokeColor: '#f00',
                                fillColor: 'rgba(255, 236, 161, 0.5)',
                                label: "name",
                                font: '12pt sans-serif',
                                isExtend: true,
                                isOnlyExtend: false,
                            }}
                            roadLineStyle={{
                                strokeWidth: 1,
                                strokeColor: '#f00',
                                fillColor: 'rgba(255, 236, 161, 0.5)',

                                font: '12pt sans-serif',
                                isExtend: true,
                                isOnlyExtend: false,
                            }}
                            doorNumberStyle={{
                                isCircle: true,
                                strokeWidth: 1,
                                strokeColor: '#f00',
                                fillColor: 'rgba(175, 255, 161, 0.5)',
                                isExtend: true,
                            }}
                            countryUrl={process.env.REACT_APP_ADDRESS_API + "api/Country/Get"}
                            cityUrl={process.env.REACT_APP_ADDRESS_API + "api/Province/Get"}
                            districtUrl={process.env.REACT_APP_ADDRESS_API + "api/District/Get"}
                            neighbourhoodUrl={process.env.REACT_APP_ADDRESS_API + "api/Neighbourhood/Get"}
                            roadLineUrl={process.env.REACT_APP_ADDRESS_API + "api/RoadLine/Get"}
                            doorNumberUrl={process.env.REACT_APP_ADDRESS_API + "api/DoorNumber/Get"}
                            cityGeometryUrl={process.env.REACT_APP_ADDRESS_API + "api/Province/GetGeometry"}
                            districtGeometryUrl={process.env.REACT_APP_ADDRESS_API + "api/District/GetGeometry"}
                            neighbourhoodGeometryUrl={process.env.REACT_APP_ADDRESS_API + "api/Neighbourhood/GetGeometry"}

                            citycolor="#"
                            showCountry={false}
                            showCity={false}
                            showDistrict={false}
                            showNeigborHood={false}
                            showDoorNumber={false}
                            showRoadLine={false}
                            selectedCountryLabel={t('addGeometry.selectCountry')}
                            selectedCityLabel={t('addGeometry.selectCity')}
                            selectedDistrictLabel={t('addGeometry.selectDistrict')}
                            selectedNeighbourhoodLabel={t('addGeometry.selectNeighbourhood')}
                            selectedRoadLineLabel={t('addGeometry.selectRoad')}
                            selectedDoorNumberLabel={t('addGeometry.selectDoorNumber')}
                            layerName="bs-hierarchial-layer"
                            id="bs-hierarchial-query-db"
                            mapTool={this.mapTool}
                            MapTool={MapTool}
                            showMapButton={true}
                            showClearButton={false}
                            onSelected={(data) => {
                            }}
                            onSelectedButton={(res) => {
                                let data = res.data;
                                setTimeout(() => {
                                    if (data.length > 0) {


                                        let addedLayers = ["bs-hierarchial-layercountry", "bs-hierarchial-layercity", "bs-hierarchial-layerdistrict", "bs-hierarchial-layerneighbourhood", "draw-layer"];

                                        let hierarchialFeatures = [];

                                        for (let value of addedLayers) {
                                            let layerNameHierachicals = `${value}`;
                                            if (this.mapTool.findLayer(layerNameHierachicals)) {

                                                this.mapTool.findLayer(layerNameHierachicals).getSource().clear();

                                            }
                                        }
                                        this.mapTool.findLayer("draw-layer").getSource().clear();
                                        for (const element of data) {

                                            let feature = MapTool.convertToFeature(element.wkt, "EPSG:4326", "EPSG:3857");

                                            feature.setStyle(this.mapTool.getBackgroundStyle({
                                                strokeWidth: 1,
                                                strokeColor: 'maroon',
                                                fillColor: 'rgba(255, 236, 161, 0.5)',
                                                label: "name",
                                                font: '10pt tahoma',
                                                isExtend: true,
                                                isOnlyExtend: false,

                                            }, { name: element.name }));

                                            feature.set("areaType", res.type);

                                            this.mapTool.addFeature('draw-layer', feature);

                                        }

                                    }
                                }, 100);




                            }}
                            projection={{
                                data: 'EPSG:4326',
                                feature: 'EPSG:3857'
                            }

                            }
                            tokenKey={"bs-core-token"}
                            isSelectedSendWkt={true}
                            onRequestStart={() => {
                                console.log("dssd")
                            }}
                        />


                    </Dialog>

                </div>

                <div className="flex">

                    <Dialog header={t('addGeometry.catchmentDrawing')} visible={showIsochroneDrawDialog} style={{ width: '400px' }} onHide={() => {
                        this.setState({ showIsochroneDrawDialog: false });
                        this.clearIsochroneInputs();
                    }}>
                        <Panel header={t('addGeometry.durationAndMode')} className="p-fluid">
                            <div className="flex flex-column row-gap-4">

                                <div className="p-field">
                                    <label htmlFor="mode">{t('addGeometry.calculationMethod')}</label>
                                    <br />
                                    <Dropdown
                                        id="mode"
                                        value={mode}
                                        options={modeOptions}
                                        optionLabel="label"
                                        onChange={this.handleModeChange}
                                        placeholder={t('addGeometry.calculationMethod')}
                                    />
                                </div>
                                <div className="p-field">
                                    <label htmlFor="duration">{t('addGeometry.accessScope')}</label>
                                    <br />
                                    <Dropdown
                                        id="duration"
                                        value={duration}
                                        options={durationOptions}
                                        optionLabel="label"
                                        onChange={this.handleDurationChange}
                                        placeholder={t('addGeometry.scopeType')}
                                    />
                                </div>
                                <div className="p-field">
                                    <label htmlFor="seconds">{this.state.isDuration ? t('addGeometry.enterMinutes') : t('addGeometry.enterMeters')}</label>
                                    <InputNumber
                                        id="seconds"
                                        value={seconds}
                                        onValueChange={(e) => this.setState({ seconds: e.value })}
                                        showButtons
                                        min={0}
                                    />
                                </div>
                                <Button label={t('addGeometry.calculate')} onClick={this.handleCalculate} />
                            </div>
                        </Panel>

                    </Dialog>
                </div>

                <div className="tool-panel-container">

                    <Button onClick={this.clear} rounded icon="pi pi-times" className="tool-panel-close-button" />
                    <div className="tool-panel-title" style={{ height: "50px" }}>

                        <span id="active-draw-span" style={{ display: "block" }}> {t('addGeometry.activeDrawing')} <b>{this.props.layerName}</b></span>
                    </div>


                    <div className="tool-group activedraw">
                        <div className="tool-group-title">
                            {t('addGeometry.activeDrawing')}

                        </div>
                        <div className="button-group">
                            <span style={{ display: "block", fontSize: "10pt" }}>{this.props.layerName}</span>
                        </div>
                    </div>
                    <div className="tool-group">

                        <div className="tool-group-title">
                            {t('addGeometry.mapTools')}

                        </div>
                        <div className="button-group">
                            <Button text tooltip={t('addGeometry.back')} tooltipOptions={{ position: 'bottom' }} icon='icon-bs-arrow-down-v2-solid-3' onClick={this.mapBack} />
                            <Button text className="ml-3" tooltip={t('addGeometry.forward')} tooltipOptions={{ position: 'bottom' }} icon='icon-bs-arrow-down-v2-solid-2' onClick={this.mapForward} />
                        </div>
                    </div>


                    <div className="tool-group">
                        <div className="tool-group-title">{t('addGeometry.drawingTools')}</div>
                        <div className="button-group">

                            {(geomType === 3 || geomType === 0) && <>
                                <Button value="Polygon" tooltip={t('addGeometry.drawPolygon')} tooltipOptions={{ position: 'bottom' }} text icon="icon-bs-trace-v1-solid" onClick={this.setDrawAction} />
                                <Button value="Circle" tooltip={t('addGeometry.drawCircle')} tooltipOptions={{ position: 'bottom' }} text icon="icon-bs-add-circle-v1" onClick={this.setDrawAction} />
                                <Button value="Box" tooltip={t('addGeometry.drawBox')} tooltipOptions={{ position: 'bottom' }} text icon="icon-bs-add-area-circle-v1-line" onClick={this.setDrawAction} />
                                <Button value="Cut" tooltip={t('addGeometry.cut')} tooltipOptions={{ position: 'bottom' }} text icon="icon-bs-cut-v1-line" onClick={this.setDrawAction} />
                                <Button text tooltip={t('addGeometry.addFromFile')} tooltipOptions={{ position: 'bottom' }} icon="icon-bs-upload-file-v1-line" onClick={this.addFromFile} />
                                <Button text tooltip={t('addGeometry.addHierarchicalArea')} tooltipOptions={{ position: 'bottom' }} icon="icon-bs-hierarchical-query-v1" onClick={this.addHiyerarchicalArea} />
                                <Button text tooltip={t('addGeometry.splitNeighborhood')} tooltipOptions={{ position: 'bottom' }} icon="icon-bs-map-v3-solid" onClick={this.divedeNeighborhoodsGeoloc} />
                                <Button text tooltip={t('addGeometry.catchmentDrawing')} tooltipOptions={{ position: 'bottom' }} icon="icon-bs-initiative-v1-solid" onClick={this.openIsochroneDraw} />
                                <Button text tooltip={t('addGeometry.gridDrawing')} tooltipOptions={{ position: 'bottom' }} icon="icon-bs-grid-v2" onClick={this.AddFeatureToGraticuleLayer} />
                                <Button text tooltip={t('addGeometry.editArea')} tooltipOptions={{ position: 'bottom' }} icon="icon-bs-select-area-v1" onClick={this.activeModifyInteraction} />
                                <Button text tooltip={t('addGeometry.autoFixArea')} tooltipOptions={{ position: 'bottom' }} icon="icon-bs-pont-line-v1-solid" onClick={this.geometryFixed} />
                            </>}

                            {(geomType === 1 || geomType === 0) && <>
                                <Button value="Point" tooltip={t('addGeometry.drawPoint')} tooltipOptions={{ position: 'bottom' }} text icon="icon-bs-map-pin-add-v1-solid" onClick={this.setDrawAction} />
                            </>}

                            {(geomType === 2 || geomType === 0) && <>
                                <Button value="Line" tooltip={t('addGeometry.drawLine')} tooltipOptions={{ position: 'bottom' }} text icon="icon-bs-add-circle-v1-solid" onClick={this.setDrawAction} />
                            </>}



                            {/*<Button text tooltip="Seç / Çizim Taşı" tooltipOptions={{ position: 'bottom' }} icon="icon-bs-move-v1" onClick={this.moveDraw} />*/}

                            {/*<Button text icon="icon-bs-copy-v1-solid" tooltipOptions={{ position: 'bottom' }} tooltip="Kopyala / Yapıştır" onClick={this.copy} />*/}

                            <Button text icon="icon-bs-close-v2-line" tooltip={t('addGeometry.closeTools')} tooltipOptions={{ position: 'bottom' }} onClick={this.disableAllDrawInteraction} />
                            <Button value="Clear" className="p-button-warning" tooltip={t('addGeometry.clearDrawings')} tooltipOptions={{ position: 'bottom' }} text icon="icon-bs--clear-selected-drawing-v2" onClick={this.setDrawAction} />
                        </div>
                    </div>



                    <div className="tool-group measure-group">

                        <div className="tool-group-title">
                            {t('addGeometry.measurementTools')}
                        </div>
                        <div className="button-group">
                            <Button text icon="icon-bs-measure-v1" tooltip={t('addGeometry.measureArea')} tooltipOptions={{ position: 'bottom' }} onClick={this.openAreaInteraction} />
                            <Button text className="p-button-warning ml-3" icon="icon-bs--clear-selected-drawing-v2" tooltip={t('addGeometry.clearMeasurement')} tooltipOptions={{ position: 'bottom' }} onClick={this.clearMeasurement} />

                        </div>

                    </div>

                    <div className="tool-group">
                        <div className="tool-group-title">
                            {t('addGeometry.operations')}
                        </div>
                        <div className="button-group">
                            <Button text className="p-button-success" icon="icon-bs-list-unordered" tooltip={t('addGeometry.additionalOperations')} tooltipOptions={{ position: 'bottom' }} onClick={() => this.setState({ isCutShowDialog: !this.state.isCutShowDialog })} />
                            <Button text className="p-button-success" icon="icon-bs-save-v1" tooltip={t('addGeometry.save')} tooltipOptions={{ position: 'bottom' }} onClick={this.saveDraw} />
                            <Button value="AddPoi" tooltip={t('addGeometry.addPoiToLayer')} tooltipOptions={{ position: 'bottom' }} text icon="icon-bs-map-pin-v4-solid" onClick={this.setDrawAction} />
                            <Button value="RemovePoi" tooltip={t('addGeometry.removePoiFromLayer')} tooltipOptions={{ position: 'bottom' }} text icon="icon-bs-map-pin-clear-v1-solid" onClick={this.removeLayerPoi} />
                            <Button text tooltip={t('addGeometry.getCurrentArea')} tooltipOptions={{ position: 'bottom' }} icon="icon-bs-visibility-v1" onClick={() => { this.clearLayer(); this.getItem(); }} />
                            <Button text className="p-button-danger" tooltip={t('addGeometry.deleteGeometry')} tooltipOptions={{ position: 'bottom' }} icon="icon-bs--clear-selected-drawing-v1" onClick={(e) => this.confirm1(e)} />
                        </div>
                    </div>

                </div >


            </>

        )
    }

}
export default withTranslation(undefined,
    { withRef: true })(AddGeometryComponent);
